import React, { useRef, useEffect, useState } from "react";
import { withScriptjs, withGoogleMap, GoogleMap } from "react-google-maps";
import Marker from "../Marker/Marker.jsx";
import mapStyles from "../../styles/mapStyles";

const Map = withScriptjs(
  withGoogleMap((props) => {
    const mapRef = useRef(null);
    const [activeInfoWindow, seActiveInfoWindow] = useState("");

    const {
      restaurants,
      searchByMoveActive,
      notPaginatedRestaurants,
      onMapPositionChange
    } = props;

    let dataSource = restaurants;

    useEffect(() => {
      if (mapRef && mapRef.current && restaurants.length) {
        let bounds = new google.maps.LatLngBounds();

        restaurants.map((restaurant, index) => {
          const { latitude, longitude } = restaurant;
          if (latitude && longitude) {
            bounds.extend(new google.maps.LatLng(latitude, longitude));
          }
        });
        mapRef.current.fitBounds(bounds);
      }
    }, props.restaurants);

    const onMapClick = () => {
      seActiveInfoWindow("");
    };

    const onDragStart = () => {
      seActiveInfoWindow("");
    };

    const settings = {
      zoom: 12,
      defaultCenter: {
        lat: 51.509865,
        lng: -0.118092,
      },
    };

    const toggleInfoWindow = (id) => {
      window.lrgDisableMapMovementCallback = true
      seActiveInfoWindow(id);
      setTimeout(() => {
        window.lrgDisableMapMovementCallback = false
      }, 1000)
    };

    if (searchByMoveActive) {
      dataSource = notPaginatedRestaurants || [];
    }

    function getMapData() {
      if (!mapRef || !mapRef.current) {
        {}
      }

      const bounds = mapRef.current.getBounds();
      if (!bounds) {
        return {
          radius: 9
        };
      }
      const center = bounds.getCenter();
      const ne = bounds.getNorthEast();

      // r = radius of the earth in statute miles
      const r = 3963.0;

      // Convert lat or lng from decimal degrees into radians (divide by 57.2958)
      const lat1 = center.lat() / 57.2958;
      const lon1 = center.lng() / 57.2958;
      const lat2 = ne.lat() / 57.2958;
      const lon2 = ne.lng() / 57.2958;

      // distance = circle radius from center to Northeast corner of bounds
      const radius =
        r *
        Math.acos(
          Math.sin(lat1) * Math.sin(lat2) +
            Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1)
        );

      if (radius < 1) {
        return {
          mapCenter: center,
          radius: 1
        }
      }

      return   {
        mapCenter: center,
        radius
      }
    }

    function handleZoomChange() {
      const {radius, mapCenter} = getMapData()

      onMapPositionChange(radius, mapCenter)
    }

    function handleMapMove() {
      const {radius, mapCenter} = getMapData()

      onMapPositionChange(radius, mapCenter)
    }

    return (
      <GoogleMap
        defaultZoom={8}
        defaultCenter={{
          lat: settings.defaultCenter.lat,
          lng: settings.defaultCenter.lng,
        }}
        defaultOptions={{
          styles: mapStyles,
          mapTypeControl: false,
        }}
        ref={mapRef}
        onClick={onMapClick}
        onDragStart={onDragStart}
        onCenterChanged={handleMapMove}
        onZoomChanged={handleZoomChange}
      >
        {dataSource &&
          dataSource.map((restaurant, index) => {
            const { latitude, longitude } = restaurant;
            return (
              <Marker
                key={index}
                restaurant={restaurant}
                lat={parseFloat(latitude)}
                lng={parseFloat(longitude)}
                toggleInfoWindow={toggleInfoWindow}
                activeInfoWindow={activeInfoWindow}
              />
            );
          })}
      </GoogleMap>
    );
  })
);

export default Map;
